import { ReactNode, FC, useMemo } from 'react';
import { Link, useLocation } from 'react-router';

export interface SubTab {
	title: string;
	link: string;
	cate: string;
}

interface SubVisualProps {
	cate: string;
	title: string;
	subTab?: SubTab[];
	children?: React.ReactNode;
	onChangeTab?: (index: number) => void;
}

const SubVisual: FC<SubVisualProps> = ({ title, cate, subTab, children, onChangeTab }) => {
	const { pathname } = useLocation();
	const tabIndex = subTab?.findIndex(tab => tab.link === pathname);
	// 현재 선택된 탭 상태 관리
	const activeTab = useMemo(() => (tabIndex !== undefined && tabIndex !== -1 ? tabIndex : 0), [tabIndex]);

	const handleTabClick = (index: number) => {
		onChangeTab?.(index);
	};

	return (
		<section className="sub-visual">
			<div className="sub-visual-inner">
				<div className="title">
					<h2>{cate}</h2>
					<strong>{title}</strong>
				</div>

				{subTab && subTab.length > 0 && (
					<div className="sub-visual-tab">
						{subTab.map((tab, index) => (
							<Link
								key={index}
								to={tab.link}
								className={`tab-btn ${activeTab === index ? 'active' : ''}`}
								onClick={() => handleTabClick(index)}>
								{tab.title}
							</Link>
						))}
					</div>
				)}

				{children}
			</div>
		</section>
	);
};

export default SubVisual;
